import {
  miscellaneousService
} from '../_services';

const state = {
  countries: {
    data: null,
    loading: false,
    updating: {},
    deleting: {},
    error: {},
  },
  tableOptions: {
    texts: {
      count:
        "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
      first: "Primero",
      last: "Último",
      filter: "Filtrar:",
      filterPlaceholder: "Buscar",
      limit: "Registros:",
      page: "Página:",
      noResults: "No hay resultados",
      filterBy: "Filtrar por {column}",
      loading: "Cargan...",
      defaultOption: "Seleccion {column}",
      columns: "Columnas"
    }, 
    headings: {},
    pagination: { chunk: 10 },
    sortIcon: {
      is: "fa-sort",
      base: "fas",
      up: "fa-sort-up",
      down: "fa-sort-down"
    }

  }

};

const actions = {

  /**
   * Countries
   * @param commit
   */
  getCountries({
    commit
  }) {
    commit('getCountriesRequest');
    miscellaneousService.getCountries()
      .then(
        users => commit('getCountriesSuccess', users),
        error => commit('getCountriesFailure', error)
      );
  },



};

const mutations = {
  /*
  ALL
   */
  getCountriesRequest(state) {
    state.countries.loading = true;
  },
  getCountriesSuccess(state, countries) {    
    state.countries.data = countries
    state.countries.loading = false
  },
  getCountriesFailure(state, error) {
    state.countries.error = error;
    state.countries.loading = false;
  },

  /* TABLEOPTIONS - opciones de una tabla vuetables */
  setTableOptions(state, data) {
    state.tableOptions = data; 
  }

};

const getters = {
  getTableOptions(state) {
    return JSON.parse(JSON.stringify(state.tableOptions));
  }
}

export const miscellaneous = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
